window.shipping =
{
    cartCTA: function ()
    {
        var handHeldToolbar = document.querySelector(".handheld-toolbar");
        var button = document.querySelector("*[data-cta-stop]");

        if (!handHeldToolbar || !button)
            return;

        var buttonOffset = document.querySelector("*[data-cta-stop]").offsetTop;
        var toolbarHeight = handHeldToolbar.getBoundingClientRect().height;

        var ctaElement = document.querySelector("*[data-cta]");

        if (!ctaElement)
            return;

        if (window.scrollY + window.outerHeight >= buttonOffset + toolbarHeight)
        {
            ctaElement.classList.add("d-none");
            handHeldToolbar.classList.remove("shadow-none");
        }
        else
        {
            ctaElement.classList.remove("d-none");
            handHeldToolbar.classList.add("shadow-none");
        }
    },
    init: function ()
    {
        var shippingForm = document.querySelector('#shipping-and-payment-form');

        if (!shippingForm)
            return;

        cart.CTA();

        window.addEventListener("scroll", cart.CTA);

        var radioButtons = document.querySelectorAll('#shipping-and-payment-form input[type="radio"]');

        if (!radioButtons)
            return;

        radioButtons.forEach(function (radioButton)
        {
            if ('shippingMapProvider' in radioButton.dataset)
                return;

            radioButton.addEventListener('change', function ()
            {
                radioButton.form.submit();
            });
        });
    }
}

//export default shipping;